(function () {
  'use strict';

  var INTERVAL_MS = 2000;
  var MOBILE_QUERY = '(max-width: 749px)';

  function initTrustSliders() {
    document.querySelectorAll('[data-taupe-trust-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-taupe-trust-track]');
      var slides = slider.querySelectorAll('.taupe-trust-strip__item');
      var dotsWrap = slider.querySelector('[data-taupe-trust-dots]');
      if (!track || slides.length < 2) return;

      var index = 0;
      var timer;
      var mq = window.matchMedia(MOBILE_QUERY);

      function clearDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
      }

      function buildDots() {
        if (!dotsWrap || dotsWrap.children.length) return;
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'taupe-trust-strip__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('data-dot', '');
          dot.setAttribute('aria-label', 'Show item ' + (i + 1));
          dot.addEventListener('click', function () {
            goTo(i);
            restart();
          });
          dotsWrap.appendChild(dot);
        });
      }

      function goTo(i) {
        index = i;
        if (mq.matches) {
          track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';
        } else {
          track.style.transform = '';
        }
        if (dotsWrap) {
          dotsWrap.querySelectorAll('[data-dot]').forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
          });
        }
      }

      function next() {
        goTo((index + 1) % slides.length);
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      function restart() {
        stop();
        if (mq.matches) {
          timer = window.setInterval(next, INTERVAL_MS);
        }
      }

      function activate() {
        if (mq.matches) {
          buildDots();
          goTo(index);
          restart();
        } else {
          stop();
          clearDots();
          goTo(0);
        }
      }

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', restart);

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', activate);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(activate);
      }

      activate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustSliders);
  } else {
    initTrustSliders();
  }

  document.addEventListener('shopify:section:load', initTrustSliders);
})();
